"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnforcerAdapter = exports.Adapter = void 0;
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _enforcer = require("./enforcer");
var Adapter = exports.Adapter = /*#__PURE__*/function () {
  function Adapter() {
    (0, _classCallCheck2.default)(this, Adapter);
  }
  (0, _createClass2.default)(Adapter, null, [{
    key: "forOxygen",
    value: function forOxygen(initialState) {
      var _this = this;
      return new Proxy(Object.create(null), {
        get: function get(_target_, p) {
          if (initialState !== null && initialState !== void 0 && initialState.user) {
            //
            var _iterator = (0, _createForOfIteratorHelper2.default)(p.split(',')),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var action = _step.value;
                //
                var result = _enforcer.Enforcer.check(_this.buildContext({
                  user: initialState.user,
                  request: {
                    action: action,
                    resource: []
                  }
                }));
                //
                if (result !== 'Allow') {
                  return false;
                }
              }
              //
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return true;
          } else {
            return false;
          }
        }
      });
    }
  }, {
    key: "forHelium",
    value: function forHelium(context) {
      // 判断是否包含可用的用户信息 | 如果包含则继续鉴权, 否则直接返回假
      if (context.user) {
        return _enforcer.Enforcer.check(this.buildContext(context)) === 'Allow';
      } else {
        return false;
      }
    }
  }, {
    key: "buildContext",
    value: function buildContext(context) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, context), {}, {
        policies: [].concat((0, _toConsumableArray2.default)(context.user.policies), (0, _toConsumableArray2.default)(context.user.userGroups.reduce(function (previousValue, currentValue) {
          return [].concat((0, _toConsumableArray2.default)(previousValue), (0, _toConsumableArray2.default)(currentValue.policies));
        }, []))).map(function (policy) {
          return policy.payload;
        })
      });
    }
  }]);
  return Adapter;
}();
var EnforcerAdapter = exports.EnforcerAdapter = /*#__PURE__*/function (_Adapter) {
  (0, _inherits2.default)(EnforcerAdapter, _Adapter);
  var _super = (0, _createSuper2.default)(EnforcerAdapter);
  function EnforcerAdapter() {
    (0, _classCallCheck2.default)(this, EnforcerAdapter);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2.default)(EnforcerAdapter);
}(Adapter);